import { colorGrey4, colorBlue1 } from './../../../../../scss/_colors.scss';

export const options = {
    filtering: false,
    search: true,
    sorting: true,
    paging: true,
    emptyRowsWhenPaging: true, // it defaults to true, adding it here so we remember it exists
    showTitle: false,
    tableLayout: 'auto',
    searchFieldAlignment : 'left',
    padding: 'dense',
    pageSize: 25,
    pageSizeOptions: [25, 50, 100],
    searchFieldStyle : {
        backgroundColor : colorGrey4,
        marginTop: '1.5rem',
        padding: '5px 2px',
        color: colorBlue1,
        width: '400px',
        fontSize: '16px !important',
        borderBottom: 'none !important',
        borderRadius: '3px',
    },
    filterCellStyle: {
        paddingTop: '0px !important',
        paddingBottom: '0px !important',
    }
};

export function optionsBuilder(overrides = {}) {
    return {
        ...options,
        ...overrides,
    };
}
